import {json, texture} from "p3";
import common from "../../../common";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import CoinAnimation from "../misc/CoinAnimation";
import Item from "./Item";

export default class ItemAcorn extends Item {
    constructor(properties) {
        super(definitions.ITEM_ID.ACORN, texture("prop_acorn_00"));

        this._properties = properties;
        this._instance = null;
    }

    init() {
        super.init();

        ////console.log('ACORN', this._properties);

        for (let i in this._properties) {
            if (this._properties[i].name == 'instance') {
                this._instance = this._properties[i].value;
            }
        }
        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }

    spawn() {
        if (common.saveData.activeSlot.acorns.indexOf(this._instance) < 0) {
            super.spawn();
        }
    }

    collect() {
        if (common.saveData.activeSlot.acorns.length == 0) {
            GameScene.active.assignQuestManually('acorns', 'badger');
        }
        if (common.saveData.activeSlot.acorns.indexOf(this._instance) < 0) {
            common.saveData.activeSlot.acorns.push(this._instance);
            common.saveData.saveGame();

            super.collect();

            const data = json('badger');
            if(common.saveData.activeSlot.acorns.length >= data.quests.acorns.metadata.target) {
                GameScene.active.completeQuestManually('acorns', 'badger');
                const coins = new CoinAnimation(data.quests.acorns.metadata.coinReward, GameScene.active);
                coins.x = this.x;
                coins.y = this.y;
                this.parent.addChild(coins);
                common.saveData.activeSlot.coins += data.quests.acorns.metadata.coinReward;
                common.saveData.saveGame();
                GameScene.active.inventory.addItem(definitions.ITEM_ID.ACORN, data.quests.acorns.metadata.target);
                return false;
            }

            return true;
        }
        return false;
    }
}